/**
 * the pcon planner module will only be used once on every page and
 * currently only included as area. there we are allowed to use document.querySelector
 * to search for the start button of the overlay and because it is not inside
 * the pcon module itself
 */

import './pcon-planner.scss';
import { Overlay } from '../../components/overlay/overlay';

class PconPlanner {
    constructor ($pconPlanner) {
        this.$pconPlanner = $pconPlanner;
        this.$overlay = this.$pconPlanner.querySelector('[data-overlay="root"]');
        this.$startButton = document.querySelector('[data-pcon-planner="start"]');
    }

    initialize () {
        if (this.$overlay) {
            this.overlay = new Overlay(this.$overlay);
            this.overlay.initialize();

            this.bindEvents();
        }
    }

    bindEvents () {
        if (this.$startButton) {
            this.$startButton.addEventListener('click', () => {
                this.overlay.showOverlay();
                this.setIframeSource();
            });
        }
    }

    // to prevent unnecessary data exchange, we load the iframe when the overlay is visible
    setIframeSource () {
        const $iframe = this.$overlay.querySelector('iframe');
        const src = this.$pconPlanner.getAttribute('data-url');
        // prevent setting source multiple times
        const hasSource = this.$pconPlanner.getAttribute('data-init') === 'true';

        if (!hasSource) {
            $iframe.src = src;
            this.$pconPlanner.setAttribute('data-init', 'true');
        }
    }
}

export { PconPlanner };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$roots = $context.querySelectorAll('[data-pcon-planner="root"]');
        $$roots.forEach($root => {
            const $rootAPI = new PconPlanner($root);
            $rootAPI.initialize();
        });
    }
});
